import { render, staticRenderFns } from "./Create-Supplier.vue?vue&type=template&id=05c8043b"
import script from "./Create-Supplier.vue?vue&type=script&lang=js"
export * from "./Create-Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports